import {FAILURE, PENDING, SUCCESS} from './constants'

import {getSettings as getSettingsApi} from '../../../services/settings'

export async function getSettings(dispatch) {
  try {
    dispatch({type: PENDING})
    const response = await getSettingsApi()
    dispatch({type: SUCCESS, payload: {data: response}})
    return response
  } catch (e) {
    console.log(`Get Settings Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
